import HttpResponse from "../../../../../../utils/http/http.response";

export enum BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel {
  ABA = "ABA",
  SABS = "SABS",
  AB = "AB",
  OTHER = "OTHER",
}

export type BillingsOrderCargoRailyRecalculateResponseDataContractCargoCompany =
  {
    companyName: string;
  };

export type BillingsOrderCargoRailyRecalculateResponseDataContract = {
  model: BillingsOrderCargoRailyRecalculateResponseDataContractBillingModel;
  allowChargeWhileApproaching: boolean;
  allowChargeWhileReturning: boolean;
  allowChargeDuringRide: boolean;
  distanceRate: number;
  haltingTimeRate: number;
  discountLimit: number;
  haltingTimeAfterMinutes: number;
  cargoCompany: BillingsOrderCargoRailyRecalculateResponseDataContractCargoCompany;
};

export type BillingsOrderCargoRailyRecalculateResponseDataBillingNode = {
  id: string;
  nodeId: string;
  lat: number;
  lon: number;
  description: string;
  checkoutDate: Date | null;
  checkoutEventId: string | null;
  plannedDate: Date | null;
  orderId: string | null;
  distance: number;
  plannedDistance: number;
  haltingTime: number;
  highwayCharge: number;
  allowCharge: boolean;
  editableCoordinates: boolean;
};

export type BillingsOrderCargoRailyRecalculateResponseDataCargoOrder = {
  id: string;
  humanId: number;
};

export type BillingsOrderCargoRailyRecalculateResponseData = {
  contract: BillingsOrderCargoRailyRecalculateResponseDataContract;
  billingNodes: BillingsOrderCargoRailyRecalculateResponseDataBillingNode[];
  discountAmount: number;
  totalAmount: number;
  haltingAmount: number;
  highwayCharge: number;
  distance: number;
  discount: number;
  distanceAmount: number;
  cargoOrder: BillingsOrderCargoRailyRecalculateResponseDataCargoOrder;
  planEntryId: string;
  date: Date;
};

type BillingsOrderCargoRailyRecalculateResponse =
  HttpResponse<BillingsOrderCargoRailyRecalculateResponseData>;

export default BillingsOrderCargoRailyRecalculateResponse;
